<template>
  <div v-if="!isPWAInstalled" class="footer-container d-flex flex-column flex-md-row" style="
      backdrop-filter: blur(10px);
      background-color: rgba(0, 0, 0, 0.8) !important;
      bottom: 0;
      left: 0;
      position: fixed;
      width: 100%;
      z-index: 101;
      padding: 10px 15px;
    ">
    <div class="logo-container d-none d-md-flex col-md-2 img-fluid" style="display: flex">
      <img style="max-height: 60px; margin: auto" src="/img/urmedicalamarillo.svg" />
    </div>

    <div class="text-container col-12 col-md-6 text-start mb-2">
      <p class="text-title" style="font-weight: bold; color: #fff">
        Descarga Tu Oficina Virtual
      </p>
      <p class="text-description" style="color: #fff">
        Instala el PWA de URMEDICAL en tu 
        {{ device }} para utilizarlo como aplicación sin la necesidad de que ingreses a un navegador.
      </p>
      <p v-if="isIOS" class="text-description" style="color: #fff">
        Haz click en compartir y agrégala a tu pantalla principal.
      </p>
      <p v-if="isMac && isSafari && device === 'computadora'" class="text-description" style="color: #fff">
        Haz click en Archivo, Compartir, y agrégala a tu menú.
      </p>
    </div>

    <div class="button-container col-12 col-md-4 d-flex"
      style="margin-top: 10px; justify-content: center; align-items: center">
      <div align="center" style="display: flex; gap: 8px; height: fit-content">
        <button v-if="!isIOS && !isSafari" style="margin-bottom: 10px; border: 2px solid #0c75ba !important"
          class="btn btn-primary btn-md" @click="installPWA">
          Instalar app
        </button>

        <button style="
            margin-bottom: 10px;
            background-color: #f0f2f5 !important;
            color: black !important;
            border: 2px solid white !important;
          " class="btn btn-md btn-secondary" @click="dismissPrompt">
          Ahora no
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {

  },
  props: ['installEvent'],
  data() {

    const ua = navigator.userAgent

    let device = "";


    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      //es tablet
      device = "tablet";

    } else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
      //es mobile
      device = "celular";

    } else {
      //es destopk
      device = "computadora";



    }


    return {
      device: device,
      isIOS: false,
      isMac: false,
      isSafari: false,
      isPWAInstalled: false,

    }
  },
  created() {

  },
  beforeMount() {

  },
  mounted() {



  },
  methods: {

    dismissPrompt() {
      this.$eventBus.emit('ocultarPWA')
    },

    installPWA() {
      this.installEvent.prompt()
      this.installEvent.userChoice.then((choice) => {
        this.dismissPrompt() // Hide the prompt once the user's clicked
        if (choice.outcome === 'accepted') {
          // Do something additional if the user chose to install
        } else {
          // Do something additional if the user declined
        }
      })
    },


  },
}
</script>

<style scoped>
/* Adjustments for small screens */

/* Smaller font size and margin for mobile screens */
.text-title {
  font-size: 18px;
  margin-top: 10px;
  margin-bottom: 5px;
}

.text-description {
  font-size: 16px;
  margin-bottom: 5px;
}

@media (max-width: 576px) {
  .text-title {
    font-size: 16px;
    margin-top: 10px;
    margin-bottom: 5px;
  }

  .text-description {
    font-size: 14px;
    margin-bottom: 5px;
  }

  .button-container {
    margin-top: 0;
  }
}

/* Adjustments for medium and larger screens */
@media (min-width: 576px) {
  .footer-container {
    flex-direction: row;
  }
}
</style>